import { CoverageCard } from '../CoverageCard';
import { BenefitDto } from 'theSource/queries';
import { SubscriberResponseDto } from 'theSource/types';
import { DependentDto } from 'theSource/features/FamilyMembers/types';
import './BenefitCategorySection.css';
import { CategoryCoverageDto } from 'enrollment/queries/useBenefitCategoryQuery/types';

interface BenefitCategorySectionProps {
  benefits?: BenefitDto[];
  category: string;
  subscriberProfile?: SubscriberResponseDto;
  dependents?: DependentDto[];
}

export const BenefitCategorySection = ({
  benefits,
  category,
  subscriberProfile,
  dependents,
}: BenefitCategorySectionProps) => {
  if (benefits?.length === 0) {
    return <></>;
  }


  const isNonDeclinedTermination = (coverage: CategoryCoverageDto) => {
    if (!coverage) {
      return false;
    }
    const startDate = new Date(coverage.change_effective_date || '');
    const terminationDate = new Date(coverage.termination_date || '');

    if (!terminationDate || !startDate) {
      return false;
    }
    if (coverage.req_coverage_level_lookup_code === 'decline') {
      return false;
    }
    if (terminationDate <= new Date() || startDate >= terminationDate) {
      return true;
    }

    return false;
  };

  const filterBenefits = benefits && benefits?.filter((item) => {
    const reqSubscriberValue = Number(item?.coverage?.req_subscriber_premium);
    return item?.benefit_class !== 'survey' || (item?.benefit_class === 'survey' && reqSubscriberValue > 0);
  });

  const showCategoryTitle = category !== 'Survey' && (filterBenefits && filterBenefits?.length > 0);

  return (
    <>
      {showCategoryTitle && <div className={category.toLowerCase().replace(/\s+/g, '')}>
        <h2 className="mb-3">{category}</h2>
        {filterBenefits &&
          filterBenefits.map((benefit: BenefitDto) => {
            const coverage = benefit.coverage || undefined;
            return isNonDeclinedTermination(coverage) ? null : (
              <CoverageCard
                coverage={coverage}
                benefit={benefit}
                subscriberProfile={subscriberProfile}
                dependents={dependents}
                inEligible={isNonDeclinedTermination(coverage)}
              />
            );
          })}
      </div>}
    </>
  );
};
